import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

export const getLoginPath = () => {
  return urlHelper('/');
};
